<template lang="pug">
.form-group
  label.control-label Repeats
  AppSelect(
    v-model="selected"
    :options="options"
    @input="onSelectChange"
  )
</template>

<script>
export default {
  name: 'AttendanceSchedulesRecurringSelect',
  props: {
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selected: {
      get() {
        return this.form.repeatSchedule || (this.options.length && this.options[0].id) || null;
      },
      set(value) {
        this.$emit('updated', value, 'repeatSchedule');
      },
    },
  },
  methods: {
    onSelectChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>
